// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__6hUWC","modalOtherContent":"styles_modalOtherContent__3-_ja","modalContent":"styles_modalContent__3Z6LY"};